import { createSelector } from 'reselect';

import {
  // Frame
  hasUserSelector,
  // Navigation
  appsSelector,
  loginWithXingSelector,
  shareButtonSelector,
  downloadsSelector,
  // Props
  localeSelector,
} from '../../selectors';
import { localizedLink } from '../../selectors/utils';

export default createSelector(
  hasUserSelector,
  localeSelector,
  appsSelector,
  loginWithXingSelector,
  shareButtonSelector,
  downloadsSelector,
  (hasUser, locale, apps, loginWithXing, shareButton, downloads) => {
    return [apps, loginWithXing, shareButton, hasUser && downloads]
      .filter(Boolean)
      .map(localizedLink(locale));
  }
);
